import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Funciona si mi bebé solo se calma en brazos?',
    answer: 'Sí: el protocolo incluye transiciones y cierre PM mínimo. No buscamos dejar de cogerlo, sino ordenarlo.'
  }, {
    question: '¿Y si doy pecho / biberón / mixto?',
    answer: 'Sirve igual: el kit adapta el tramo crítico sin obsesión con cantidades. El enfoque es en la rutina y el ambiente.'
  }, {
    question: '¿Cuánto tiempo necesito?',
    answer: '10 minutos de preparación + 20 minutos de protocolo. Está diseñado para mamás con poco tiempo y energía.'
  }];
  return <section className="py-20 px-4 md:px-6 bg-white" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <h2 className="font-serif text-3xl text-[#1a2e4a] font-bold mb-10 text-center" data-id="element-32">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-34" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#d4a0a0]/30 rounded-xl overflow-hidden bg-[#faf6f0]/30" data-id="element-35">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-[#faf6f0]/50 transition-colors" data-id="element-36">
        <span className="font-serif text-lg font-medium text-[#1a2e4a]" data-id="element-37">
          {question}
        </span>
        <span className="ml-4 text-[#c4956a]" data-id="element-38">
          {isOpen ? <Minus size={20} data-id="element-39" /> : <Plus size={20} data-id="element-40" />}
        </span>
      </button>

      <AnimatePresence data-id="element-41">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-42">
            <div className="px-6 pb-6 pt-0 text-[#5a5a5a] leading-relaxed" data-id="element-43">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}